module.exports = __webpack_public_path__ + "img/bg-tile-opacity-20.5d383d77.png";